import { createStore, Store } from "vuex";
import { RootState } from "./types"; // Import RootState
import { auth } from "@/services/auth/auth.service";
import MenuStore from "./modules/MenuStore";
import ErrorModalStore from "./modules/ErrorModalStore";
import OrderStore from "./modules/OrderStore";
import TourStore from "./modules/TourStore";
import UserStore from "./modules/UserStore";
import { setAuthorizationHeader } from "@/api/config";

export default createStore<RootState["state"]>({
  state: (): RootState["state"] => ({
    user: {
      username: "",
      token: "",
      termsAccepted: false,
      data: {
        user_id: "",
        company: {
          id: "",
          name: "",
          company_type: "",
          operator_id: "",
        },
        company_id: "",
        license_plate: "",
      },
    },
    isLoading: false,
  }),
  getters: {
    isLoggedIn(state) {
      return !!auth?.currentUser;
    },
    isLoading(state) {
      return state.isLoading;
    },
  },
  mutations: {
    SET_USERNAME(state, username: string) {
      state.user.username = username;
    },
    SET_TOKEN(state, token: string) {
      state.user.token = token;
      setAuthorizationHeader(token);
    },
    SET_DATA(state, data: any) {
      state.user.data = data;
    },
    SET_LOADING(state, loading: boolean) {
      state.isLoading = loading;
    },
  },
  actions: {
    addUser({ commit }, { username, token, data = [] }) {
      commit("SET_USERNAME", username);
      commit("SET_TOKEN", token);
      commit("SET_DATA", data);
    },
    removeUser({ commit }) {
      commit("SET_USERNAME", "");
      commit("SET_TOKEN", "");
      commit("SET_DATA", []);
    },
    toggleLoading({ commit }, loading: boolean) {
      commit("SET_LOADING", loading);
    },
  },
  modules: {
    MenuStore,
    ErrorModalStore,
    OrderStore,
    TourStore,
    UserStore,
  },
});
